import { render, staticRenderFns } from "./IqAgentStep.vue?vue&type=template&id=137ffc73&scoped=true"
import script from "./IqAgentStep.vue?vue&type=script&setup=true&lang=js"
export * from "./IqAgentStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IqAgentStep.vue?vue&type=style&index=0&id=137ffc73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ffc73",
  null
  
)

export default component.exports